import { Spinner as NbSpinner } from 'native-base';

import { getDesignToken } from 'styles/constants';

import { addWithConfig } from '../../utils';

import type { SpinnerProps } from './types';

export const Spinner = ({ reversed, ...props }: SpinnerProps) => (
  <NbSpinner
    color={
      reversed
        ? getDesignToken('background-loader-indicator-reversed')
        : getDesignToken('icon-active')
    }
    {...props}
  />
);

export default addWithConfig(Spinner);
